<ng-container *ngIf="versionText$ | async as version">
  <pre class="text-secondary text-center text-normal">{{ version.versionText }}</pre>
</ng-container>
